import type { PropsWithChildren } from 'react';
import { ToastContainer } from 'react-toastify';
// TODO: migrate all x-date-pickers / x-date-pickers-pro to v.6 project wide
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { LocalizationProvider as LocalizationProviderV6 } from '@mui/x-date-pickers-pro-v.6';
import { AdapterMoment as AdapterMomentV6 } from '@mui/x-date-pickers-pro-v.6/AdapterMoment';
import { useBootstrap, useHistoryReset } from "hooks";
import ThemeProvider from 'theme';
import ThemeLocalization from 'locales';
import routes from 'routes';
import { withStore } from "infrastructure/store";
import { withRouter, createBrowserRouter } from 'infrastructure/router';
import ContextPublisher from 'providers/ContextPublisher';
import { SettingsProvider, ThemeSettings } from "lib/settings";
import SnackbarProvider from 'lib/snackbar';
import { MotionLazyContainer } from 'lib/animate';
import AppNotification from "ui/widgets/Notificator";
import UnsavedChanges from 'ui/widgets/UnsavedChanges';
import 'react-toastify/dist/ReactToastify.css';
import 'simplebar/src/simplebar.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'locales/i18n';
import "./index.css";

const App = ({ children }: PropsWithChildren) => {
  useBootstrap();
  useHistoryReset();

  return (
    <HelmetProvider>
      <LocalizationProviderV6 dateAdapter={AdapterMomentV6}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <SettingsProvider>
            <MotionLazyContainer>
              <ThemeProvider>
                <ThemeSettings>
                  <ThemeLocalization>
                    <SnackbarProvider>
                      <ContextPublisher>
                        <UnsavedChanges>
                          {children}
                        </UnsavedChanges>
                      </ContextPublisher>
                      <AppNotification />
                    </SnackbarProvider>
                  </ThemeLocalization>
                </ThemeSettings>
              </ThemeProvider>
            </MotionLazyContainer>
          </SettingsProvider>
        </LocalizationProvider>
      </LocalizationProviderV6>
      <ToastContainer />
    </HelmetProvider>
  );
};

export default withStore(
  withRouter(App, () => createBrowserRouter(routes))
);
